export * from "./card-content.component";
